// Content managed from the admin dashboard
import api from './api'

// The whole homepage in one request: { configured, sections: [...] }
export async function getHomeContent() {
  const { data } = await api.get('/content/home')
  return data
}

export async function getSiteSettings() {
  const { data } = await api.get('/content/settings')
  return data
}

// What a page's <head> should say (title, description, canonical, robots, Open Graph, JSON-LD), resolved by the API
// from the SEO fields managed in the admin dashboard.
export async function getSeoMeta(path, query = {}) {
  const { data } = await api.get('/seo/meta', { params: { path, ...query } })
  return data
}

// Header, footer, logos, stores, About/Contact/Help/policy pages, product-page values — managed in the dashboard.
export async function getSiteContent() {
  const { data } = await api.get('/content/site')
  return data
}

// Optimised (WebP/AVIF, several widths) copies of library images, for responsive <picture>s.
export async function getMediaIndex() {
  const { data } = await api.get('/content/media-index')
  return data.images || {}
}

// Blog, pages created in the dashboard, and FAQs.
export async function getBlogPosts(params = {}) {
  const { data } = await api.get('/content/blog/posts', { params })
  return data
}
export async function getBlogPost(slug) {
  const { data } = await api.get(`/content/blog/posts/${encodeURIComponent(slug)}`)
  return data
}
export async function getBlogCategories() {
  const { data } = await api.get('/content/blog/categories')
  return data
}
export async function getCustomPage(slug) {
  const { data } = await api.get(`/content/custom-pages/${encodeURIComponent(slug)}`)
  return data
}
export async function getFaqs() {
  const { data } = await api.get('/content/faqs')
  return data.groups
}

// Product attributes (frame shape, material, lens coating…) — drive the shop filters and the specifications table.
export async function getAttributes() {
  const { data } = await api.get('/content/attributes')
  return data.attributes
}
